import React from 'react'
import { NavLink } from 'react-router-dom'
import KeycloakService from '../../../utils/keycloakService'
import {
  DIAGNOSIS_READ,
  DIAGNOSIS_WRITE,
  LAB_ORDERS_READ,
  LAB_ORDERS_WRITE,
  MEDICATIONS_READ,
  MEDICATIONS_WRITE,
} from '../../../utils/roles'
import '../../opd/opd.scss'

interface MenuProps {
  setSelectedMenu: (menu: string) => void
  setSelectedDate?: any
  id: string | null
}

const IpdVisitMenu = (props: MenuProps) => {
  const { setSelectedMenu, setSelectedDate } = props
  return (
    <div className='opd-menu'>
      <ul>
        {KeycloakService.hasRole([LAB_ORDERS_READ, LAB_ORDERS_WRITE]) && (
          <li>
            <NavLink
              to={`vitals?regId=${props?.id}`}
              onClick={() => {
                setSelectedMenu('vitals')
                setSelectedDate()
              }}
            >
              Vitals
            </NavLink>
          </li>
        )}
        {KeycloakService.hasRole([DIAGNOSIS_READ, DIAGNOSIS_WRITE]) && (
          <li>
            <NavLink
              to={`diagnosisIpd?regId=${props?.id}`}
              onClick={() => setSelectedMenu('diagnosisIpd')}
            >
              Diagnosis
            </NavLink>
          </li>
        )}
        {KeycloakService.hasRole([MEDICATIONS_READ, MEDICATIONS_WRITE]) && (
          <li>
            <NavLink
              to={`medications?regId=${props?.id}`}
              onClick={() => setSelectedMenu('medications')}
            >
              Medications
            </NavLink>
          </li>
        )}
        {KeycloakService.hasRole([MEDICATIONS_READ, MEDICATIONS_WRITE]) && (
          <li>
            <NavLink
              to={`treatmentPlan?regId=${props?.id}`}
              onClick={() => setSelectedMenu('treatmentPlan')}
            >
              Treatment Plan
            </NavLink>
          </li>
        )}
        {KeycloakService.hasRole([LAB_ORDERS_READ, LAB_ORDERS_WRITE]) && (
          <li>
            <NavLink
              to={`lab-orders?regId=${props?.id}`}
              onClick={() => setSelectedMenu('lab-orders')}
            >
              Lab Orders
            </NavLink>
          </li>
        )}
        {KeycloakService.hasRole([LAB_ORDERS_READ, LAB_ORDERS_WRITE]) && (
          <li>
            <NavLink
              to={`radiology-orders?regId=${props?.id}`}
              onClick={() => setSelectedMenu('radiology-orders')}
            >
              Radiology Orders
            </NavLink>
          </li>
        )}
        {KeycloakService.hasRole([LAB_ORDERS_READ, LAB_ORDERS_WRITE]) && (
          <li>
            <NavLink
              to={`icuChart?regId=${props?.id}`}
              onClick={() => setSelectedMenu('icuChart')}
            >
              ICU Chart
            </NavLink>
          </li>
        )}
        {KeycloakService.hasRole([DIAGNOSIS_READ, DIAGNOSIS_WRITE]) && (
          <li>
            <NavLink
              to={`invasiveLineIpd?regId=${props?.id}`}
              onClick={() => setSelectedMenu('invasiveLineIpd')}
            >
              Invasive Lines
            </NavLink>
          </li>
        )}
        {/* {KeycloakService.hasRole([LAB_ORDERS_READ, LAB_ORDERS_WRITE]) && (
          <li>
            <NavLink
              to='progressNote'
              onClick={() => setSelectedMenu('progressBar')}
            >
              Progress Notes
            </NavLink>
          </li>
        )} */}
      </ul>
    </div>
  )
}

export default IpdVisitMenu
